import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import butterfly from "../../assets/butterfly-1.svg";
import cartoon from "../../assets/cartoon.gif";
import { getCompanyProfile } from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import PaymentComponent from "./PaymentComponent"; // Import PaymentComponent

const BuyPremium = ({ closeModal }) => {
  const [companySubscriptionEndDate, setCompanySubscriptionEndDate] =
    useState(null);
  const [isSubscriptionValid, setIsSubscriptionValid] = useState(true);
  const [pointValue, setPointValue] = useState(50);
  const pricePerPoint = 200;
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isPayment, setIsPayment] = useState(false);

  const CompanyEmailID = localStorage.getItem("CompanyEmailID");

  const isAuthorizedUser =
    // CompanyEmailID === "dattatray+ui@varahitechnologies.com";
    CompanyEmailID === "sachin@varahitechnologies.com";

  const handlePackageSelect = (packageInfo) => {
    const price =
      packageInfo.title === "TopUp"
        ? pointValue * pricePerPoint
        : packageInfo.price;
    setSelectedPackage({ ...packageInfo, price: price });
  };

  const handleRangeChange = (event) => {
    setPointValue(parseInt(event.target.value));
  };

  const handlePayment = () => {
    if (selectedPackage && !isPayment) {
      setIsPayment(true); // Set the payment state to true to render PaymentComponent
    }
  };

  const handlePaymentClose = () => {
    setIsPayment(false);
    setSelectedPackage(null);
  };

  // Use useEffect to handle the state update completion for selectedPackage
  useEffect(() => {
    if (selectedPackage && !isPayment) {
      setIsPayment(true);
    }
  }, [selectedPackage]);

  const fetchCompanyProfile = async () => {
    try {
      const storedCompanyID = localStorage.getItem("CompanyProfileID");
      const companyProfileData = await API.graphql(
        graphqlOperation(getCompanyProfile, { id: storedCompanyID })
      );

      if (companyProfileData.data.getCompanyProfile) {
        const companyProfile = companyProfileData.data.getCompanyProfile;
        const endDate = new Date(companyProfile.CompanySubscriptionEndDate);
        setCompanySubscriptionEndDate(endDate);

        // Check if current date is greater than subscription end date
        const currentDate = new Date();
        if (currentDate > endDate) {
          setIsSubscriptionValid(false);
        }
      } else {
        console.error("Company profile not found");
      }
    } catch (error) {
      console.error("Error fetching company profile:", error);
    }
  };

  useEffect(() => {
    fetchCompanyProfile();
  }, []);

  const modalContent = (
    <div 
      className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center"
      style={{
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(10px)'
      }}
      onClick={closeModal}
    >
      <div 
        className="w-full max-w-4xl mx-4 rounded-xl shadow-2xl"
        style={{
          background: '#111827',
          border: '1px solid rgba(75, 85, 99, 0.5)',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5)',
          maxHeight: '80vh'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div 
          className="px-5 py-4 border-b flex justify-between items-center"
          style={{
            background: 'rgba(31, 41, 55, 0.9)',
            borderColor: 'rgba(75, 85, 99, 0.5)',
            borderRadius: '12px 12px 0 0'
          }}
        >
          <div>
            <h2 className="text-xl font-bold text-white">
              Buy More Credits
            </h2>
            <p className="text-xs text-gray-400 mt-0.5">
              1 screening: <span className="line-through text-gray-500">₹300</span> <span className="text-indigo-400 font-semibold">₹200</span>
            </p>
          </div>
          <button
            onClick={closeModal}
            className="p-1.5 rounded-full text-gray-400 hover:bg-gray-700 hover:text-white transition-all duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Scrollable Content */}
        <div 
          className="p-4 overflow-y-auto"
          style={{
            maxHeight: 'calc(80vh - 70px)',
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(75, 85, 99, 1) rgba(31, 41, 55, 1)'
          }}
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {[
              {
                title: "Monthly",
                JD: "Unlimited",
                screening: 30,
                points: 300,
                price: 6000,
                strikethrough: 9000,
              },
              {
                title: "Half Yearly",
                JD: "Unlimited",
                screening: 180,
                points: 1500,
                price: 36000,
                strikethrough: 54000,
              },
              {
                title: "Yearly",
                JD: "Unlimited",
                screening: 360,
                points: 3000,
                price: 72000,
                strikethrough: 108000,
              },
            ].map((packageInfo, index) => (
              <div
                key={index}
                className="rounded-lg p-3 transition-all duration-200 hover:scale-[1.02] flex flex-col"
                style={{
                  background: 'rgba(31, 41, 55, 0.7)',
                  border: '1px solid rgba(75, 85, 99, 0.5)'
                }}
              >
                <h5 className="text-sm font-bold text-center text-indigo-400 mb-2">
                  {packageInfo.title}
                </h5>
                
                <div className="text-xs text-gray-400 space-y-1 mb-3">
                  <div className="flex items-center gap-1.5">
                    <span className="text-indigo-400">✓</span>
                    <span>JD: {packageInfo.JD}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-indigo-400">✓</span>
                    <span>Screenings: {packageInfo.screening}</span>
                  </div>
                </div>
                
                <div className="text-center py-2 border-t border-gray-700 mb-3">
                  <span className="text-xs text-gray-500 line-through block">
                    ₹{packageInfo.strikethrough.toLocaleString()}
                  </span>
                  <span className="text-xl font-bold text-white">
                    ₹{packageInfo.price.toLocaleString()}
                  </span>
                </div>
                
                <div className="mt-auto">
                  <button
                    type="button"
                    className="w-full text-white text-xs font-semibold py-2 px-3 rounded-md transition-all duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{
                      background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                    }}
                    onClick={() => handlePackageSelect(packageInfo)}
                    disabled={!isAuthorizedUser}
                  >
                    SUBSCRIBE
                  </button>

                  <div className="mt-2 space-y-1.5">
                    <input
                      type="text"
                      placeholder="Coupon Code"
                      className="w-full bg-gray-800 border border-gray-700 rounded px-2 py-1.5 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500"
                    />
                    <button
                      className="w-full text-white text-xs font-medium py-1.5 px-2 rounded bg-gray-700 hover:bg-gray-600 transition-colors disabled:opacity-50"
                      disabled={!isAuthorizedUser}
                    >
                      Validate
                    </button>
                  </div>
                </div>
              </div>
            ))}
            
            {/* TopUp Package */}
            <div
              className="rounded-lg p-3 transition-all duration-200 hover:scale-[1.02] flex flex-col"
              style={{
                background: 'rgba(31, 41, 55, 0.7)',
                border: '1px solid rgba(75, 85, 99, 0.5)'
              }}
            >
              <h5 className="text-sm font-bold text-center text-indigo-400 mb-2">
                TopUp
              </h5>
              
              {/* This div takes up the same space as benefits + price in other cards */}
              <div className="text-xs text-gray-400 space-y-1 mb-3">
                <div className="flex items-center gap-1.5">
                  <span className="text-indigo-400">✓</span>
                  <span>Custom Points</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-indigo-400">✓</span>
                  <span>Flexible Amount</span>
                </div>
              </div>
              
              <div className="text-center py-2 border-t border-gray-700 mb-3">
                <input
                  type="range"
                  id="pointRange"
                  name="pointRange"
                  min="10"
                  max="500"
                  step="10"
                  value={pointValue}
                  onChange={handleRangeChange}
                  className="w-full h-1.5 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-indigo-500 mb-1"
                  style={{
                    WebkitAppearance: 'none',
                    appearance: 'none'
                  }}
                />
                <span className="text-xs text-gray-500 block">{pointValue} Points</span>
                <span className="text-xl font-bold text-white">
                  ₹{(pointValue * pricePerPoint).toLocaleString()}
                </span>
              </div>
              
              <div className="mt-auto">
                <button
                  type="button"
                  className="w-full text-white text-xs font-semibold py-2 px-3 rounded-md transition-all duration-200 hover:opacity-90 disabled:opacity-50"
                  style={{
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                  }}
                  onClick={() => {
                    if (!isAuthorizedUser) {
                      alert("You are in test mode. This action is not available.");
                    } else if (!isSubscriptionValid) {
                      alert("Your validity is over. Please subscribe to a package to extend your validity.");
                    } else {
                      handlePackageSelect({ title: "TopUp", points: pointValue });
                    }
                  }}
                >
                  TopUp
                </button>

                <div className="mt-2 space-y-1.5">
                  <input
                    type="text"
                    placeholder="Offer Code"
                    className="w-full bg-gray-800 border border-gray-700 rounded px-2 py-1.5 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500"
                  />
                  <button
                    className="w-full text-white text-xs font-medium py-1.5 px-2 rounded bg-gray-700 hover:bg-gray-600 transition-colors disabled:opacity-50"
                    disabled={!isAuthorizedUser}
                  >
                    Validate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isPayment && selectedPackage && (
        <PaymentComponent
          packageInfo={selectedPackage}
          onPaymentClose={handlePaymentClose}
          companySubscriptionEndDate={companySubscriptionEndDate}
        />
      )}
    </div>
  );

  // Use React Portal to render modal at document body level
  return ReactDOM.createPortal(modalContent, document.body);
};

export default BuyPremium;
